// 正式
module.exports = {
  title: 'MG Thailand',
  baseUrl: 'https://sns-thai.mgthai.com/b3',
  // 正式项目地址
  baseApi: 'https://sns-thai.mgthai.com/bom3',
  // 正式api请求地址
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: 'https://www.sunniejs.cn/static'
};